const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const useAsyncSafeState = require('./hooks/async-safe');
const { FontAwesomeIcon } = require('@fortawesome/react-fontawesome');
const fontAwesomeIcons = require('./font-awesome-icons');

function clearAndUpper(text) {
  return text.replace(/-/, '').toUpperCase();
}

function toPascalCase(text) {
  return text.replace(/(^\w|-\w)/g, clearAndUpper);
}

function processName(name) {
  if (!name) {
    return '';
  }
  let realName = name;
  if (realName.substring(0, 3) === 'fa-') {
    // this handles cases like 'fa-fan'
    realName = `fa${toPascalCase(name.substring(3))}`;
  }

  if (realName.substring(0, 2) !== 'fa' || realName.charAt(2) !== realName.charAt(2).toUpperCase()) {
    // this handles cases like 'weight', or names that start with 'fa' like 'fan'
    realName = toPascalCase(realName);
    realName = `fa${realName}`;
  }
  return realName;
}

/**
 * @deprecated use FontAwesomeIcon from the @fortawesome/react-fontawesome package directly
 * @returns {React.ReactNode}
 */
function FaIcon({ name, className = '', title = '' }) {
  const [icon, setIcon] = useAsyncSafeState();

  React.useEffect(() => {
    try {
      const realName = processName(name);
      if (realName) {
        const realIcon = fontAwesomeIcons.default[realName];
        if (!realIcon) {
          throw new Error(
            `Icon "${realName}" not found. Please make sure that this icon has been added to the list located in src/font-awesome-icons/index for use.`,
          );
        }
        setIcon(realIcon);
      }
    } catch (error) {
      console.error(error);
    }
  }, [setIcon, name]);

  if (!name || !icon) {
    return null;
  }

  const svgProps = {
    className: classnames('icon', className),
    title,
  };

  return icon ? <FontAwesomeIcon icon={icon} {...svgProps} /> : <div {...svgProps} />;
}

FaIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired, // can be in faNameOfComponent _or_ name-of-component _or_ fa-name-of-component
  title: PropTypes.string,
};

/**
 * @deprecated use FontAwesomeIcon from the @fortawesome/react-fontawesome package directly
 */
const memoFaIcon = React.memo(FaIcon);

module.exports = memoFaIcon;
